import { createAction, props } from '@ngrx/store';

const stockIsCreated = 'STOCK_IS_CREATED';
const removeRecentStock = 'REMOVE_RECENT_STOCK';
export const stockIsCreatedAction = createAction(
  stockIsCreated,
  props<{ newStock: any }>()
);

export const removeRecentStockAction = createAction(removeRecentStock);
